<section
  formEnhance
  [callback]="search"
  [bindTo]="formBind"
  [primeNgDropdowns]="hasSearchDropDowns"
  [autoCompleteControls]="hasAutoCompleteControls"
  class="FIND_DR_PROFILES"
>
  <div class="l-flex l-flex-wrap t-panel l-align-y">
    <input-wrap>
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="profileId"
        placeholder="{{ 'translate.general.profileId' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <input-wrap [loading]="clinicList && clinicList.loading">
      <p-select
        #hasSearchDropdown
        [options]="clinicList"
        optionLabel="label"
        [(ngModel)]="selectedClinic"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.clinic' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedClinic"
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedClinic != null"
        (click)="selectedClinic = null; search()"
      ></clear-multi>
    </input-wrap>

    <span class="spacer t-space--small"></span>
    <input-wrap [loading]="doctorList && doctorList.loading">
      <p-select
        #hasSearchDropdown
        [options]="doctorList"
        optionLabel="label"
        [(ngModel)]="selectedDoctor"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.doctor' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedDoctor"
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      >
      </p-select>

      <clear-multi
        *ngIf="selectedDoctor != null"
        (click)="selectedDoctor = null; search()"
      ></clear-multi>
    </input-wrap>

    <span class="spacer t-space--med"></span>
    <button class="t-button t-button--flat" (click)="search()">
      {{ "translate.general.search" | translate }}
    </button>

    <span class="spacer t-space--small"></span>
    <button class="t-button-outline c-c1" (click)="onCreateClicked()">
      {{ "translate.mng.createDrProfile" | translate }}
    </button>
  </div>
</section>
